// @ts-nocheck

import { setIsLoading } from '../actions/history';
import networkActionCreators from '../actions/network';
import { HistoryActionTypes } from '../types/actions//history';
import { CashoutActionTypes } from '../types/actions/cashout';

const interceptOn = [
  HistoryActionTypes.INIT,
  HistoryActionTypes.NEXT_OFFSET,
  HistoryActionTypes.PREV_OFFSET,
  HistoryActionTypes.SET_OFFSET,
  HistoryActionTypes.SET_FILTER,
  HistoryActionTypes.SET_BETSLIP_TYPE,
  HistoryActionTypes.SET_PERIOD_START,
  HistoryActionTypes.SET_PERIOD_END,
];

export default ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    if (interceptOn.indexOf(action.type) !== -1) {
      const {
        history: { offset: currentOffset },
      } = getState();
      const returnValue = next(action);
      const {
        history: { offset, limit, filter, type },
      } = getState();
      if (
        action.type === HistoryActionTypes.NEXT_OFFSET ||
        action.type === HistoryActionTypes.PREV_OFFSET ||
        action.type === HistoryActionTypes.SET_OFFSET
      ) {
        if (currentOffset !== offset) {
          dispatch(setIsLoading(true));
          dispatch(
            networkActionCreators.send(
              {
                route: 'history',
                getBetslips: { offset, limit, filter, type },
              },
              { auth: true },
            ),
          );
        }
      } else {
        dispatch(setIsLoading(true));
        dispatch(
          networkActionCreators.send(
            {
              route: 'history',
              getBetslips: { offset, limit, filter, type },
            },
            { auth: true },
          ),
        );
      }
      return returnValue;
    } else if (action.type === CashoutActionTypes.CASHOUT_SUCCESS) {
      const {
        history: { offset, limit, filter, type },
      } = getState();

      setTimeout(() => {
        dispatch(
          networkActionCreators.send(
            {
              route: 'history',
              getBetslips: { offset, limit, filter, type },
            },
            { auth: true },
          ),
        );
      }, 1500);
    }
    return next(action);
  };
